import React, { useMemo } from 'react';
import { Box, Heading } from "@chakra-ui/react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const CenteredLegend = ({ label }) => (
  <Box
    style={{
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      marginTop: 6,
      width: "100%",
    }}
  >
    <Box
      as="span"
      style={{
        alignItems: "center",
        color: "var(--blue)",
        display: "inline-flex",
        fontSize: 14,
        gap: 4,
        justifyContent: "center",
      }}
    >
      <Box
        as="span"
        aria-hidden="true"
        style={{
          border: "2px solid var(--blue)",
          borderRadius: "50%",
          height: 7,
          width: 7,
        }}
      />
      {label}
    </Box>
  </Box>
);

const LineGraph = React.memo(({ chart, title, height, lineName = "Total" }) => {
  const chartData = useMemo(() => chart, [chart]);

  const chartHeight = height ? parseInt(height) : 300;

  return (
    <Box width="100%">
      <ResponsiveContainer width="100%" height={chartHeight} debounce={300}>
        <LineChart
          data={chartData}
          margin={{
            top: 0,
            right: 10,
            left: -10,
            bottom: 15,
          }}
        >
          <CartesianGrid stroke="#EBEBEB" vertical={false} />
          <XAxis
            dataKey="date"
            name="Day"
            axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }}
          />
          <YAxis axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }} />

          <Tooltip />
          <Line
            type="monotone"
            strokeWidth={1.6}
            dataKey="rate"
            name={lineName}
            stroke={"var(--blue)"}
            dot={{ fill: "var(--blue)", r: 2 }}
            activeDot={{ r: 4 }}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
      <CenteredLegend label={lineName} />
      <Heading
        size="sm"
        fontWeight={400}
        fontSize="14px"
        color="#535353"
        mb="20px"
        textAlign="center"
      >
        {title}
      </Heading>
    </Box>
  );
});

export default LineGraph;
